import { useMemo } from "react"
import { Card, Button, Space } from "antd"
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons"
import RoleTable from "./components/RoleTable"
import RoleModal from "./components/RoleModal"
import { useCrud } from "@/hooks/useCrud"
import { Role, RoleFormData } from "./types"
import roleApi from "./api"
import { ID } from "@/types/common"

const RoleManagement = () => {
  const api = useMemo(
    () => ({
      getList: () => roleApi.getList(),
      create: roleApi.create,
      update: (id: ID, data: RoleFormData | Partial<RoleFormData>) =>
        roleApi.update(id, data as RoleFormData),
      delete: roleApi.delete,
    }),
    []
  )

  const {
    items: roles,
    loading,
    opLoading,
    isModalOpen,
    editingItem: editingRole,
    selectedIds,
    setSelectedIds,
    pagination,
    handleAdd,
    handleEdit,
    handleSave,
    handleDelete,
    handleBatchDelete,
    handleCloseModal,
    handlePageChange,
  } = useCrud<Role, RoleFormData>({
    api,
    entityName: "角色",
    pagination: {
      enabled: true,
      pageSize: 10,
    },
  })

  // 计算统计数据
  const totalRoles = pagination.total
  const selectedCount = selectedIds.length
  const batchDisabled = selectedCount === 0

  return (
    <div className="p-6">
      {/* 主要内容区域 */}
      <Card>
        {/* 操作栏 */}
        <div className="flex justify-between items-center mb-4">
          <div>
            <span className="text-gray-500">共 {totalRoles} 个角色</span>
          </div>
          <Space>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAdd}
              loading={opLoading}
              data-testid="btn-add-role"
            >
              新增角色
            </Button>
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={handleBatchDelete}
              disabled={batchDisabled}
              loading={opLoading}
              data-testid="btn-batch-delete"
            >
              批量删除 {selectedCount > 0 && `(${selectedCount})`}
            </Button>
          </Space>
        </div>

        {/* 角色表格 */}
        <RoleTable
          roles={roles}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={loading}
          selectedIds={selectedIds}
          onSelectionChange={setSelectedIds}
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onPageChange={handlePageChange}
        />
      </Card>

      {/* 角色信息模态框 */}
      <RoleModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSave}
        role={editingRole}
        loading={opLoading}
      />
    </div>
  )
}

export default RoleManagement
